module.exports = __webpack_public_path__ + "static/media/logo.901fada0.png";